var styleDataHash = '6821046f';  
export const injectCss = (() => {
  var css = `.kaH1I{box-sizing:border-box;height:29px;margin:0 auto;max-width:100%;padding-top:14px;width:100%}.h-hbU{padding-top:11px}.ocfWd{display:block;stroke:currentColor;stroke-width:1;shape-rendering:crispEdges}.Ga0Zg,.fn1Bv,.hc9VC,.xHlih{height:100%}.Ga0Zg{stroke-dasharray:4 4}.xHlih{stroke-dasharray:1 5}.Tvp5i{width:10%}.JAqmM{width:40%}.ULbJt{width:100%}.zsbri{margin-right:auto}.digjW{margin:0 auto}._8gvFr{margin-left:auto}.yXqHu{height:100%}.yXqHu .bfLl5{height:1px}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});





